import { buildApiUrl } from '../config/api.js'

const ENDPOINT = buildApiUrl('/diagnostico/notif')

const throttleAt = new Map()

const shouldThrottle = (payload, windowMs = 4000) => {
  const key = [
    payload.code || '',
    payload.event || '',
    payload.event_id || '',
    payload.comanda_id || 0
  ].join('|')
  const now = Date.now()
  const prev = throttleAt.get(key) || 0
  if (now - prev < windowMs) return true
  throttleAt.set(key, now)
  if (throttleAt.size > 300) {
    for (const [k, ts] of throttleAt) {
      if (now - ts > 60000) throttleAt.delete(k)
    }
  }
  return false
}

const getAuthHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
  'Content-Type': 'application/json'
})

export const reportNotifDiagnostic = (payload = {}) => {
  try {
    if (!payload?.code) return
    if (shouldThrottle(payload, payload.code === 'RECEIVE' ? 3000 : 6000)) return
    const token = localStorage.getItem('token')
    if (!token) return

    const body = JSON.stringify({
      level: payload.level || (payload.code === 'RECEIVE' ? 'info' : 'warn'),
      code: payload.code,
      event: payload.event || null,
      event_id: payload.event_id || null,
      comanda_id: Number(payload.comanda_id || 0) || null,
      vista: payload.vista || (typeof window !== 'undefined' ? window.location?.pathname : null),
      msg: payload.msg || null,
      extra: payload.extra && typeof payload.extra === 'object' ? payload.extra : undefined
    })

    fetch(ENDPOINT, {
      method: 'POST',
      headers: getAuthHeader(),
      body,
      keepalive: true
    }).catch(() => {})
  } catch (_error) {
    // no interrumpir operación
  }
}

export const fetchNotifDiagnostic = async (params = {}) => {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === '') return
    query.set(key, String(value))
  })
  const response = await fetch(`${ENDPOINT}?${query.toString()}`, {
    headers: getAuthHeader()
  })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    throw new Error(data.message || `Error ${response.status}`)
  }
  return data.data || { items: [], counts: {}, total: 0 }
}
